<template>
  <v-card outlined>
    <div class="px-4 pt-3 pb-1 d-flex align-center">
      <v-icon small class="mr-1 grey--text">mdi-history</v-icon>
      <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1">
        Movimentações ({{ movimentacoes.length }})
      </span>
    </div>

    <v-progress-linear v-if="carregando" indeterminate />

    <div v-else class="px-2">
      <div v-if="movimentacoes.length === 0" class="text-center grey--text text-caption py-6">
        Nenhuma movimentação registrada.
      </div>

      <v-timeline v-else align-center dense class="pt-1">
        <v-timeline-item
          v-for="item in movimentacoes"
          :key="item.id"
          small
          :color="item.estorno ? 'red darken-1' : 'green darken-1'"
        >
          <div class="d-flex align-center flex-wrap mb-1 movimentacao__chips">
            <v-chip
              x-small
              :color="item.estorno ? 'red lighten-4' : 'green lighten-4'"
              :text-color="item.estorno ? 'red darken-3' : 'green darken-3'"
              class="font-weight-bold"
            >
              {{ item.estorno ? "−" : "+" }} {{ item.valor | currency }}
            </v-chip>
            <v-chip v-if="item.estorno" x-small color="red lighten-4" text-color="red darken-3">
              Estornado
            </v-chip>
          </div>
          <div class="text-caption grey--text">{{ item.created_at | longDate }}</div>
          <div v-if="item.user" class="text-caption grey--text text--darken-1 mt-1">
            <v-icon x-small class="mr-1">mdi-account-outline</v-icon>{{ item.user.name }}
          </div>
          <div v-if="item.caixa" class="text-caption grey--text text--darken-1">
            <v-icon x-small class="mr-1">mdi-cash-register</v-icon>{{ item.caixa.descricao }}
          </div>
        </v-timeline-item>
      </v-timeline>
    </div>
  </v-card>
</template>

<script>
import { mensagemDeErro } from "./helpers";

/**
 * Movimentações de caixa da parcela, com o mesmo visual da seção "Movimentações" do Drawer da
 * mensalidade. Somente leitura: estorno e baixa não têm regra definida para pré-matrícula.
 */
export default {
  name: "EHistoricoDePagamentos",
  props: {
    parcelaId: { type: Number, required: true },
  },
  data() {
    return { movimentacoes: [], carregando: false };
  },
  async mounted() {
    this.carregando = true;
    try {
      const resposta = await this.$services.parcelasService.getHistorico(this.parcelaId);
      this.movimentacoes = resposta.data.mensalidades || [];
    } catch (error) {
      this.$toast.danger(mensagemDeErro(error));
    }
    this.carregando = false;
  },
};
</script>

<style scoped>
.movimentacao__chips {
  gap: 4px;
}
</style>
